import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  ITagDefinition,
  ITagDefinitionRow,
} from '../../../../view/settings/api-automation-settings/tag-definitions/tag-definitions.model';

@Injectable({
  providedIn: 'root',
})
export class TagDefinitionService {
  private readonly TAG_DEFINITION_URL = `${this.baseUrl}/api-automation/tag-definition`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<ITagDefinition>> {
    return this.http.get<GetManyResponseInterface<ITagDefinition>>(this.TAG_DEFINITION_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<ITagDefinition>> {
    return this.http.get<BaseOneResponseInterface<ITagDefinition>>(`${this.TAG_DEFINITION_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: ITagDefinitionRow): Observable<BaseOneResponseInterface<ITagDefinition>> {
    return this.http.post<BaseOneResponseInterface<ITagDefinition>>(this.TAG_DEFINITION_URL, record);
  }

  public editOne(recordId: number, record: ITagDefinitionRow): Observable<BaseOneResponseInterface<ITagDefinition>> {
    return this.http.patch<BaseOneResponseInterface<ITagDefinition>>(`${this.TAG_DEFINITION_URL}/${recordId}`, record);
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          tagDefinitions: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.TAG_DEFINITION_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.TAG_DEFINITION_URL}/${recordIds[0]}`);
  }
}
